/**
 * Group Icon Renderer - AD group node icon
 *
 * Renders two overlapping silhouettes to represent a group/collection.
 */

import { getIconConfig } from '@/components/icons/nodeIcons/config/iconConfig';
import { getThemeColors } from '@/components/icons/nodeIcons/config/themeColors';
import {
  calculateIconPosition,
  drawCircleBackground,
  setupCanvas,
} from '@/components/icons/nodeIcons/renderers/base';

export const createGroupIconDataURL = (
  currentTheme: 'light' | 'dark',
  isHighlighted: boolean = false
): string => {
  const config = getIconConfig('group');
  const colors = getThemeColors('group', currentTheme, isHighlighted);
  const { canvas, ctx, size, centerX, centerY } = setupCanvas(config);

  drawCircleBackground(ctx, centerX, centerY, size, config.scale, colors);

  const { x, y, scale } = calculateIconPosition(centerX, centerY, size, config);

  ctx.save();
  ctx.translate(x, y);
  ctx.scale(scale, scale);
  ctx.strokeStyle = colors.icon;
  ctx.lineWidth = 1.6;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';

  const peopleOutline = new Path2D(
    'M1 18C1 15.75 4 15.75 5.5 14.25 6.25 13.5 4 13.5 4 9.75 4 7.25025 4.99975 6 7 6 9.00025 6 10 7.25025 10 9.75 10 13.5 7.75 13.5 8.5 14.25 10 15.75 13 15.75 13 18M12.7918114 15.7266684C13.2840551 15.548266 13.6874862 15.3832994 14.0021045 15.2317685 14.552776 14.9665463 15.0840574 14.6659426 15.5 14.25 16.25 13.5 14 13.5 14 9.75 14 7.25025 14.99975 6 17 6 19.00025 6 20 7.25025 20 9.75 20 13.5 17.75 13.5 18.5 14.25 20 15.75 23 15.75 23 18'
  );
  const connector = new Path2D(
    'M12,16 C12.3662741,15.8763472 12.6302112,15.7852366 12.7918114,15.7266684'
  );

  ctx.stroke(peopleOutline);

  ctx.beginPath();
  ctx.stroke(connector);

  ctx.restore();

  return canvas.toDataURL('image/png', 1.0);
};
